import Immutable from 'immutable';
import _ from 'lodash';
import {
  PAGE_SET_MANY,
  PAGE_UPDATE_MANY,
  SET_PAGE_SUBPAGE_LIST,
  CREATE_PAGE_SUCCESS,
} from './actions';
import {
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
} from '../Feeds/actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { PROGRESS_PAGE_SUCCESS } from '../Courses/CourseProgress/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';
import { SAVE_PAGE_SETTINGS_SUCCESS } from '../PageSettings/actions';
import { MOVE_BLOCK_START } from '../Blocks/actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';
import { PageContext } from '../../web/containers/BlockPage/consts';

const DEFAULT_STATE = Immutable.fromJS({
  byPath: {},
  byCoursePath: {},
  subpagesByPath: {},
});

const setPages = (state, pages) => {
  const pagesByPath = _.reduce(
    pages,
    (current, page) => {
      current[page.path] = page; // eslint-disable-line no-param-reassign
      return current;
    },
    {}
  );
  const pagesByCoursePath = _.reduce(
    pages,
    (current, page) => {
      if (!current[page.coursePath]) {
        current[page.coursePath] = {}; // eslint-disable-line no-param-reassign
      }
      current[page.coursePath][page.id] = page; // eslint-disable-line no-param-reassign
      return current;
    },
    {}
  );
  return state
    .set('byPath', state.get('byPath').merge(Immutable.fromJS(pagesByPath)))
    .set('byCoursePath', Immutable.fromJS(pagesByCoursePath));
};

export function Pages(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case CREATE_PAGE_SUCCESS:
    case PAGE_SET_MANY:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS:
    case FEED_DATA_LOAD_MORE_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS: {
      const { pages } = action;
      return setPages(state, pages);
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      const { pageData, viewedFrom } = action;
      if (viewedFrom !== PageContext.HISTORY) {
        return setPages(state, [pageData]);
      } else {
        return state;
      }
    }
    case PROGRESS_PAGE_SUCCESS: {
      const { pages } = action;
      return setPages(state, pages);
    }

    case PAGE_UPDATE_MANY: {
      let newState = state;

      action.pages.forEach((pagePath) => {
        let changes = Immutable.fromJS(action.changes);

        // don't replace with empty revisionId, otherwise blockpages die
        if (changes.has('revisionId') && !changes.get('revisionId')) {
          changes = changes.remove('revisionId');
        }

        newState = newState.mergeIn(['byPath', pagePath], changes);
      });

      return newState;
    }

    case LOGOUT_SUCCESS: {
      return DEFAULT_STATE;
    }

    case SAVE_PAGE_SETTINGS_SUCCESS: {
      const {
        pageId,
        communityOptions: { isCommentRequired },
      } = action;

      const page = state.get('byPath').find((p) => p.get('id') === pageId);
      if (page) {
        return state.setIn(
          ['byPath', page.get('path'), 'isCommentRequired'],
          isCommentRequired
        );
      }
      return state;
    }
    case SET_PAGE_SUBPAGE_LIST: {
      const { pagePath, subpages } = action;
      return state.setIn(
        ['subpagesByPath', pagePath],
        Immutable.fromJS(subpages)
      );
    }

    case MOVE_BLOCK_START: {
      const { draggedBlock, placement, targetBlock } = action;
      const pagePath = draggedBlock.get('pagePath');

      if (targetBlock.get('id') === draggedBlock.get('id')) {
        return state; // no need to change the block index
      }

      const oldBlockIndexes = state
        .get('byPath')
        .get(pagePath)
        .get('blockIndexes');

      let newBlockIndexes = oldBlockIndexes.filter(
        (blockId) => blockId !== draggedBlock.get('id')
      );
      const insertPosition = newBlockIndexes.findIndex(
        (blockId) => blockId === targetBlock.get('id')
      );
      newBlockIndexes = newBlockIndexes.insert(
        insertPosition + (placement === 'after' ? 1 : 0), // before = insertPosition, after = position +1
        draggedBlock.get('id')
      );

      return state.setIn(['byPath', pagePath, 'blockIndexes'], newBlockIndexes);
    }

    default: {
      return state;
    }
  }
}
